export default __webpack_public_path__ + "static/media/open-ai.3c90a10a.svg";